import Vue from "vue";
import VueRouter from "vue-router";
import i18n from "../i18n";
import Root from "./Root.vue";

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/en",
  //   redirect: () => {
  //     i18n.locale = "en";
  //     return { name: "root" };
  //   },
  // },
  {
    path: "/:locale?",
    component: Root,
    children: [
      {
        path: "",
        name: "home",
        redirect: (to) => {
          const { locale } = to.params;
          //return { name: "resoluciones", params: { year: 2021, locale } };
          return { name: "resoluciones2016-2024", params: { locale } };
        },
      },
      {
        path: "resoluciones/:year",
        name: "resoluciones",
        meta: { breadcrumb: "Resoluciones" },
        component: () => import("../views/Resoluciones.vue"),
      },
      {
        path: "resoluciones2016-2024",
        name: "resoluciones2016-2024",
        meta: { breadcrumb: "Resoluciones" },
        component: () => import("../views/ResolucionesHistorico.vue"),
      },
      {
        path: "integrantes",
        name: "integrantes",
        meta: { breadcrumb: "Integrantes" },
        component: () =>
          import(/* webpackChunkName: "vistas" */ "../views/Integrantes.vue"),
      },
      {
        path: "lenguaje-claro",
        name: "lenguaje",
        meta: { breadcrumb: "Lenguaje Claro" },
        component: () =>
          import(/* webpackChunkName: "vistas" */ "../views/Lenguaje.vue"),
      },
      {
        path: "manual-procedimientos",
        name: "manual",
        meta: { breadcrumb: "Manual de Procedimientos" },
        component: () =>
          import(/* webpackChunkName: "vistas" */ "../views/Manual.vue"),
      },
      {
        path: "planificacion",
        name: "planificacion",
        meta: { breadcrumb: "Planificación" },
        component: () =>
          import(/* webpackChunkName: "vistas" */ "../views/Planificacion.vue"),
      },
      {
        path: "contacto",
        name: "contacto",
        meta: { breadcrumb: "Contacto" },
        component: () =>
          import(/* webpackChunkName: "vistas" */ "../views/Contacto.vue"),
      },
      {
        path: "ubicacion",
        name: "ubicacion",
        meta: { breadcrumb: "Ubicacion" },
        component: () =>
          import(/* webpackChunkName: "vistas" */ "../views/Ubicacion.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  let locale = to.params?.locale ?? "es";
  if (locale !== "en") locale = "es";

  if (i18n.locale !== locale) i18n.locale = locale;
  next();
});

export default router;
